import React from 'react';

/**
 * LegalFooter
 *
 * Small persistent footer surfaced on every authenticated page. It exists
 * primarily to satisfy UK GDPR Art. 13 transparency ("information shall be
 * provided in a concise, transparent, intelligible and easily accessible
 * form") by giving users a one-click route to the current Privacy Policy
 * and Terms of Service from anywhere in the app.
 *
 * Keep the visual weight low — this is regulatory plumbing, not a primary
 * navigation surface. The links open in a new tab so users do not lose the
 * app context they were in.
 */
export default function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      role="contentinfo"
      style={{
        padding: '16px 20px calc(16px + env(safe-area-inset-bottom, 0px)) 20px',
        fontSize: 12,
        color: 'var(--dusk-500)',
        textAlign: 'center',
        borderTop: '1px solid var(--mist-200)',
        background: 'var(--mist-100)',
      }}
    >
      <div style={{ marginBottom: 4 }}>
        ProVault Ltd is the <strong>data controller</strong> for your account
        and vault data. We process your personal data in the UK.
      </div>
      <div>
        <a
          href="https://provault.io/privacy"
          target="_blank"
          rel="noreferrer"
          style={{ color: 'var(--sage-700)', marginRight: 12 }}
        >
          Privacy Policy
        </a>
        <a
          href="https://provault.io/terms"
          target="_blank"
          rel="noreferrer"
          style={{ color: 'var(--sage-700)', marginRight: 12 }}
        >
          Terms of Service
        </a>
        <a
          href="https://provault.io/sub-processors"
          target="_blank"
          rel="noreferrer"
          style={{ color: 'var(--sage-700)', marginRight: 12 }}
        >
          Sub-processors
        </a>
        <a
          href="mailto:privacy@provault.io"
          style={{ color: 'var(--sage-700)' }}
        >
          privacy@provault.io
        </a>
      </div>
      <div style={{ marginTop: 4, opacity: 0.7 }}>© {year} ProVault Ltd</div>
    </footer>
  );
}
